import React from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for hero headings
export const MaskText = ({ lines, delay = 0, className = "", lineClassName = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden py-[0.05em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * 0.12, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const SectionLabel = ({ children, index, className = "" }) => (
  <Reveal className={`flex items-center gap-4 ${className}`}>
    {index && (
      <span className="font-mono text-xs text-ely-primary">{index}</span>
    )}
    <span className="h-px w-10 bg-ely-border" />
    <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-ely-muted">
      {children}
    </span>
  </Reveal>
);

export const GoldButton = ({ children, variant = "solid", className = "", ...props }) => {
  const base =
    "group inline-flex items-center gap-3 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-all duration-500 ease-out";
  const styles =
    variant === "solid"
      ? "bg-ely-primary text-ely-bg hover:bg-ely-primaryHover hover:-translate-y-0.5"
      : "border border-ely-border text-ely-text hover:border-ely-primary hover:text-ely-primary";
  return (
    <button className={`${base} ${styles} ${className}`} {...props}>
      {children}
    </button>
  );
};

export const Waveform = ({ active = false, bars = 42, className = "" }) => (
  <div className={`flex h-8 items-center gap-[3px] ${className}`}>
    {Array.from({ length: bars }).map((_, i) => (
      <span
        key={i}
        className="w-[2px] rounded-full bg-ely-primary/70"
        style={{
          height: `${20 + Math.abs(Math.sin(i * 0.9)) * 80}%`,
          animation: active ? `waveform 1.1s ease-in-out ${i * 0.04}s infinite` : "none",
          transformOrigin: "center",
        }}
      />
    ))}
  </div>
);
